import React from 'react'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import { IUserInfoResponse } from 'protos'

import Grid from '@material-ui/core/Grid'

import T from 'components/FormattedMessage'

import MostSelectedItem from './MostSelectedItem'

export interface Props {
  player?: IUserInfoResponse['favoritePlayer']
  team?: IUserInfoResponse['favoriteTeam']
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing() * 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const MostSelected: React.SFC<InjectedProps> = ({ classes, player, team }) => (
  <Grid className={classes.root} direction="row" justify="space-around" container>
    <MostSelectedItem
      jersey={player && player.jersey}
      label={<T id="userprofile_stat_favoriteplayer" />}
      name={player && player.name}
    />
    <MostSelectedItem
      jersey={team && team.jersey}
      label={<T id="userprofile_stat_favoriteteam" />}
      name={team && team.name}
    />
  </Grid>
)

export default withStyles(styles)(MostSelected)
